var render = function (_h,_vm) {var _c=_vm._c;return _c('label',_vm._g(_vm._b({staticClass:"tracking-wider text-gray-800",class:_vm.$options.methods.mergeFunctionalRenderContextClasses(_vm.data)},'label',_vm.data.attrs,false),_vm.listeners),[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.props.text)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }